import {Field, FieldArray, Formik} from "formik";
import MenuItem from "@material-ui/core/MenuItem";
import GenericModal from "../../Modals/GenericModal";
import React from "react";
import {makeStyles} from "@material-ui/core/styles";
import * as Yup from "yup";
import useRoleData from "../../../hooks/DataProvider/useRoleData";
import useFicheTypeData from "../../../hooks/DataProvider/useFicheTypeData";
import useLocationData from "../../../hooks/DataProvider/useLocationData";
import useCauseData from "../../../hooks/DataProvider/useCauseData";
import TextField from "../../Ui/TextField";
import LocationInput from "../../Ui/LocationInput";
import FileInput from "../../Ui/FileInput";
import Button from "@material-ui/core/Button";

const useStyles = makeStyles(theme => ({
    modalContainer: {
        position: 'absolute',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(4),
        outline: 'none',
    },
    textFieldContainer: {
        display: 'block',
        width: '100%'
    }
}));



const CreateEditUserForm = React.forwardRef(
    (props,ref) => {

        const {onSubmitForm,user,ValidationSchema,isSubmittingUser,initialValues} = props

        const [isLoadingRoles, roles] = useRoleData()

        const [selectedCommune, setSelectedCommune] = React.useState();
        const [isLoadingVille,villes] = useLocationData('villes')
        
        const [childMap,setChildMap] = React.useState({});

        React.useEffect(()=>{

            if(villes && initialValues.locations){

                const childs = initialValues.locations.map(
                    location => {

                        let communes = [];
                        let quartiers = [];
                        let rues = [];

                        if(location.ville)
                            communes =  getItemBy(villes,location.ville)?.communes || []

                        if(location.commune)
                            quartiers = getItemBy(communes,location.commune)?.quartiers || []

                        if(location.quartier)
                            rues = getItemBy(quartiers,location.quartier)?.rues || []


                        return {
                            communes,quartiers,rues
                        }
                    }
                ).reduce(
                    (accumulator,item,index) => {
                       accumulator[index] = item;
                       return accumulator
                    },{}
                );

                setChildMap(childs)


            }

        },[villes,initialValues.locations])

        const classes = useStyles();

        function getItemBy(array,itemId){
            return array.find(item=>item.id === itemId)
        }
        
        function updateChildMap(index,value,type){

            let childs = childMap[index];

            let communes = childs.communes;
            let quartiers = childs.quartiers;
            let rues = childs.rues;

            if(type == 'ville'){

                communes = getItemBy(villes,value)?.communes || [];
                quartiers = [];
                rues = [];

            }
            
            else if(type == 'commune'){

                quartiers = getItemBy(communes,value).quartiers;
                rues= []

            }
            
            else if(type == 'quartier'){

                rues = getItemBy(quartiers,value).rues;

            }

            setChildMap({
                ...childMap,
                [index]: {
                    communes,quartiers,rues
                }
            })
            
        }

        function removeLocationItem(map,index){

            return Object.values(map).filter((item,i)=>index!==i)
                .reduce(
                    (accumulator,item,index) => {
                        accumulator[index] = item;

                        return accumulator;
                    },{}
                )

        }


        return (
            <Formik
                innerRef={ref}
                onSubmit={(values,formikHelpers)=>{

                    console.log(values)

                    formikHelpers.setSubmitting(false);

                    if(onSubmitForm)
                        onSubmitForm(values);
                }}
                enableReinitialize={true}
                validationSchema={ValidationSchema}
                initialValues={initialValues}
            >

                {
                    (formikHelpers) => {

                        return (
                            <div className={'row'}>

                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'nom'}
                                        label={'Nom'}
                                        required={true}
                                        component={TextField}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>

                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'prenoms'}
                                        label={'Prénoms'}
                                        required={true}
                                        component={TextField}
                                        className={'h5'}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>

                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'email'}
                                        label={'Email'}
                                        required={true}
                                        component={TextField}
                                        className={'h5'}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>

                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'phone'}
                                        required={true}
                                        label={'Numéro de téléphone'}
                                        component={TextField}
                                        type={'phone'}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>
                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'matricule'}
                                        required={true}
                                        label={'Numéro matricule'}
                                        component={TextField}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>
                                <div className={'col-6 my-1'}>

                                    <Field
                                        name={'role'}
                                        component={TextField}
                                        required={true}
                                        label={'Role'}
                                        fullWidth={true}
                                        select
                                    >

                                        {roles.map(
                                            item => {
                                                return (
                                                    <MenuItem value={item.id}
                                                              key={item.id}>{item.name}</MenuItem>
                                                )
                                            }
                                        )}
                                    </Field>

                                </div>

                                <div className={'col-6 my-1'}>

                                    <Field
                                        name={'societe'}
                                        component={TextField}
                                        required={true}
                                        label={'Societe'}
                                        fullWidth={true}
                                        select
                                    >

                                        <MenuItem value={'cie'}
                                        >
                                            CIE
                                        </MenuItem>

                                        <MenuItem value={'sodeci'}
                                        >
                                            SODECI
                                        </MenuItem>

                                    </Field>

                                </div>

                                <div className={'col-6 my-1'}>
                                    <Field
                                        variant="outlined"
                                        name={'password'}
                                        required={true}
                                        label={'Mot de passe'}
                                        component={TextField}
                                        type={'password'}
                                        fullWidth={true}
                                        disabled={isSubmittingUser}
                                    />
                                </div>

                                <div className={'col-12 my-1'}>


                                    
                                    <div>

                                        <div>
                                            <Button onClick={()=>{

                                                setChildMap({
                                                    ...childMap,
                                                    [Object.values(childMap).length]: {
                                                        communes: [],
                                                        quartiers: [],
                                                        rues: [],
                                                    }
                                                })

                                                formikHelpers.setFieldValue('locations',[
                                                    ...formikHelpers.values.locations,
                                                    {
                                                        ville: undefined,
                                                        commune: undefined,
                                                        quartier: undefined,
                                                        rue: undefined
                                                    }
                                                ])
                                            }} class={'btn btn-secondary'}>
                                                Ajouter une zone
                                            </Button>
                                        </div>

                                        <FieldArray name={'locations'}
                                                    render={(arrayHelpers) => {
                                                        return formikHelpers.values.locations.map(
                                                            (item,index) => {

                                                                const childs = childMap[index];
                                                                console.log('child map',index,childs)
                                                                
                                                                return (
                                                                    
                                                                    <div className={'row'}>

                                                                        <div className="col-12">


                                                                            <Button onClick={()=>{
                                                                                arrayHelpers.remove(index)
                                                                                setChildMap(
                                                                                    removeLocationItem(childMap,index)
                                                                                )
                                                                            }}>
                                                                                supprimer
                                                                            </Button>
                                                                        </div>

                                                                        <div className={'col-lg-3 col-12'}>

                                                                            <Field

                                                                                name={`locations.${index}.ville`}
                                                                                component={TextField}
                                                                                label={'Ville'}
                                                                                variant="outlined"
                                                                                fullWidth={true}
                                                                                variant="outlined"
                                                                                select

                                                                                onChange={(e)=>{
                                                                                    formikHelpers.handleChange(e);

                                                                                    formikHelpers.setFieldValue(`locations.${index}.commune`,undefined);
                                                                                    formikHelpers.setFieldValue(`locations.${index}.quartier`,undefined);
                                                                                    formikHelpers.setFieldValue(`locations.${index}.rue`,undefined);
                                                                                    updateChildMap(index,e.target.value,'ville')

                                                                                }}
                                                                            >

                                                                                {villes.map(
                                                                                    item => {
                                                                                        return (
                                                                                            <MenuItem value={item.id}
                                                                                                      key={item.id}>{item.libelle}</MenuItem>
                                                                                        )
                                                                                    }
                                                                                )}
                                                                            </Field>

                                                                        </div>

                                                                        {
                                                                            childs?.communes.length > 0 && (



                                                                            <div className={'col-lg-3 col-12'}>

                                                                                    <Field

                                                                                        name={`locations.${index}.commune`}
                                                                                        component={TextField}
                                                                                        label={'Commune'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                        variant="outlined"
                                                                                        select
                                                                                        onChange={(e)=>{
                                                                                            formikHelpers.handleChange(e);

                                                                                            formikHelpers.setFieldValue(`locations.${index}.quartier`,undefined);
                                                                                            formikHelpers.setFieldValue(`locations.${index}.rue`,undefined);
                                                                                            updateChildMap(index,e.target.value,'commune')

                                                                                        }}
                                                                                    >

                                                                                        {childs.communes.map(
                                                                                            item => {
                                                                                                return (
                                                                                                    <MenuItem value={item.id}
                                                                                                              key={item.id}>
                                                                                                        {item.libelle}
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            }
                                                                                        )}
                                                                                    </Field>


                                                                                </div>
                                                                            )
                                                                        }

                                                                        {

                                                                            childs?.quartiers.length > 0 && (

                                                                                <div className={'col-lg-3 col-12'}>

                                                                                    <Field

                                                                                        name={`locations.${index}.quartier`}
                                                                                        component={TextField}
                                                                                        label={'Quartier'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                        variant="outlined"
                                                                                        select
                                                                                        onChange={(e)=>{
                                                                                            formikHelpers.handleChange(e);

                                                                                            formikHelpers.setFieldValue(`locations.${index}.rue`,undefined);
                                                                                            updateChildMap(index,e.target.value,'quartier')

                                                                                        }}
                                                                                    >

                                                                                        {childs.quartiers.map(
                                                                                            item => {
                                                                                                return (
                                                                                                    <MenuItem value={item.id}
                                                                                                              key={item.id}>
                                                                                                        {item.libelle}
                                                                                                    </MenuItem>
                                                                                                )
                                                                                            }
                                                                                        )}
                                                                                    </Field>

                                                                                </div>

                                                                            )

                                                                        }


                                                                        {
                                                                            childs?.rues.length > 0 && (

                                                                                <div className={'col-lg-3 col-12'}>

                                                                                    <Field

                                                                                        name={`locations.${index}.rue`}
                                                                                        component={TextField}
                                                                                        label={'Rue'}
                                                                                        variant="outlined"
                                                                                        fullWidth={true}
                                                                                        variant="outlined"
                                                                                        select
                                                                                        onChange={(e)=>{
                                                                                            formikHelpers.handleChange(e);

                                                                                            updateChildMap(index,e.target.value,'rues')

                                                                                        }}
                                                                                    >

                                                                                        {
                                                                                            childs.rues.map(
                                                                                                item => {
                                                                                                    return (
                                                                                                        <MenuItem value={item.id}
                                                                                                                  key={item.id}>
                                                                                                            {item.libelle}
                                                                                                        </MenuItem>
                                                                                                    )
                                                                                                }
                                                                                            )}
                                                                                    </Field>


                                                                                </div>

                                                                            )
                                                                        }

                                                                    </div>

                                                                )
                                                            }
                                                        )
                                                    }}
                                        />


                                    </div>
                                    
                                </div>

                            </div>
                        );

                    }
                }

            </Formik>
        );

    }
)

export default CreateEditUserForm;